import {trimStart} from 'lodash';
import {flow, mapKeys, toLower} from 'lodash/fp';

import {decode} from './query-string';

const trimQuestionMark = (str: string): string => trimStart(str, '?');

export const getQuery: <T>(query: string) => T = flow(
    trimQuestionMark,
    s => decode(s, true),
    mapKeys(toLower) as any,
);

export function getQueryParams<T extends object>() {
    return getQuery<T>(window.location.search);
}
